import { render, staticRenderFns } from "./PropertyDashboard.vue?vue&type=template&id=0953517c&scoped=true&"
import script from "./PropertyDashboard.vue?vue&type=script&lang=js&"
export * from "./PropertyDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0953517c",
  null
  
)

export default component.exports